import { FindArtResult } from '../types'
import { withLogger } from 'utils/Logger'
import { apiClient } from 'utils/apiClient'
import { withApiErrorHandled } from 'utils/common'

type GetFindArtResultBodyType = {
  artworkStyles?: Array<string>
  artworkColors?: Array<Array<number>>
  type: 'Individual'
  room?: string
  size?: Array<{
    label: string
    min: number
    max: number
  }>
  budget?: Array<{
    label: string
    min: number
    max: number
  }>
  uniqueId?: string
  iter?: number
}

async function getFindArtResults(body: GetFindArtResultBodyType) {
  const response = await withApiErrorHandled<FindArtResult>(apiClient.post)('/search/recommendations-v2', body)

  const { data } = response.data
  return data
}

export default withLogger(getFindArtResults, {
  action: 'get_find_art_results',
  customErrorText: 'Cannot get find art results',
})
